import React from 'react';

import {
  DEFAULT_SORT_BY_HEAD_CELL,
  ROWS_PER_PAGE_LABEL,
  EMPLOYEE_SESSION_FIELDS,
} from './constants';

import {
  Button,
  Checkbox,
  TableCell,
  TablePagination,
} from '@material-ui/core';
import './EmployeeSession.css';
import { ASC, DESC } from '../global/constants';
import FilterTagsBar from '../global/FilterTagsBar';
import EmployeeSessionFiltersDialog from './EmployeeSessionFiltersDialog';
import Slide from '@material-ui/core/Slide';
import { IconButton } from '@mui/material';
import SearchableTable from '../global/Search/SearchableTable';

import CustomTableHeader from '../global/Table/CustomTableHeader';
import Tooltip from '@material-ui/core/Tooltip';
import FilterIcon from '../global/FilterIcon';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import GlobalTableHead from '../global/Table/GlobalTableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';

class EmployeeSessionTable extends SearchableTable {
  constructor(props) {
    super(props);
    this.state = {
      selectedEntries: [],
      isSelecting: false,
      isSearch: false,
      searchValue: '',
      order: DESC,
      orderBy: DEFAULT_SORT_BY_HEAD_CELL,
      shownIndex: -1,
      fromDate: this.props.fromDate,
      toDate: this.props.toDate,
      filtersMap: {},
      showFilters: false,
      filtersMapBeforeOpenDialog: {},
      deletedTagsWithCookies: [],
      deleteId: '',
      selectedName: this.props.selectedName,
    };
    this.onSearchValueChange = this.onSearchValueChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.getDisplayed = this.getDisplayed.bind(this);
    this.selectAll = this.selectAll.bind(this);
  }

  async componentDidMount() {
    let changeBack = false;
    await this.setState({
      searchValue: this.props.searchText,
    });
    let storage = JSON.parse(localStorage.getItem('employeeSession'));
    if (storage) {
      this.getNewDates();
      const expiry = parseInt(JSON.parse(localStorage.getItem('expiry')));
      if (storage.fromDate !== null && storage.fromDate !== undefined) {
        if (expiry > new Date().getTime()) {
          this.onFiltersClose(true, false);
        } else {
          changeBack = true;
        }
      }
      if (storage.toDate !== null && storage.toDate !== undefined) {
        if (expiry > new Date().getTime()) {
          this.onFiltersClose(true, false);
        } else {
          changeBack = true;
        }
      }
      if (changeBack) {
        localStorage.removeItem('employeeSession');
        this.setState({
          fromDate: this.getFromDate(),
          toDate: this.getToDate(),
          filtersMap: {},
        });
      }
    }

    if (this.props.setFetchedList) {
      this.props.fetchEmployeeSessions({
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        locationId: this.props.user.selectedLocationId,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.searchText !== this.props.searchText ||
      this.state.searchValue !== this.props.searchText
    ) {
      this.initializeSearchText();
    }
  }

  handleCardClick = (name) => {
    this.uncheckAll();
    this.props.setBack(true, name);
    this.setState({ selectedName: name });
  };

  displayEmployees = () => {
    const uniqueNames = [...new Set(this.props.data.map((emp) => emp.name))];

    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          padding: '20px',
          justifyContent: 'flex-start',
          width: '97%',
        }}
      >
        {uniqueNames.map((name, index) => (
          <div
            key={index}
            onClick={() => this.handleCardClick(name)}
            style={{
              width: '140px',
              padding: '24px 16px',
              borderRadius: '16px',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow =
                '0 6px 16px rgba(0, 0, 0, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
            }}
          >
            <div
              style={{
                backgroundColor: '#f5f5f5',
                borderRadius: '50%',
                padding: '16px',
                marginBottom: '12px',
              }}
            >
              <FolderSharedOutlinedIcon
                style={{ fontSize: 32, color: '#7896ff' }}
              />
            </div>
            <div
              style={{
                fontWeight: '600',
                fontSize: '16px',
                color: '#333',
                wordWrap: 'break-word',
              }}
            >
              {name}
            </div>
          </div>
        ))}
      </div>
    );
  };

  initializeSearchText = () => {
    this.setState({ searchValue: this.props.searchText });
  };

  onSearchValueChange(e) {
    this.setState({
      isSearch: e.target.value.length > 0,
      searchValue: e.target.value,
    });
    this.props.setPage(0);
    this.props.handleSearchChange(e);
  }

  getFromDate = () => {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setDate(date.getDate() - 7);
    return date;
  };

  getToDate = () => {
    const date = new Date();
    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
    return date;
  };

  getNewDates = () => {
    let filter = { ...this.state.filtersMap };
    let storage = JSON.parse(localStorage?.getItem('employeeSession'));
    if (storage.fromDate !== null && storage.fromDate !== undefined) {
      const temp = new Date(storage.fromDate);
      filter.fromDate = temp;
      this.setState({
        fromDate: temp,
      });
    }
    if (storage.toDate !== null && storage.toDate !== undefined) {
      const temp = new Date(storage.toDate);
      filter.toDate = temp;
      this.setState({
        toDate: temp,
      });
    }

    if (filter) {
      this.setState({
        filtersMap: filter,
      });
    }
  };

  isDefaultFromDate = (someDate) => {
    const defaultFromDate = this.getFromDate();
    return (
      someDate.getDate() === defaultFromDate.getDate() &&
      someDate.getMonth() === defaultFromDate.getMonth() &&
      someDate.getFullYear() === defaultFromDate.getFullYear()
    );
  };

  isToday = (someDate) => {
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };

  addFilterDates = (filters) => {
    if (filters) {
      if (!this.isDefaultFromDate(this.state.fromDate)) {
        filters['fromDate'] = this.state.fromDate;
      }
      if (!this.isToday(this.state.toDate)) {
        filters['toDate'] = this.state.toDate;
      }
    }
    return filters;
  };

  handleChangePage = (event, newPage) => {
    this.props.setPage(newPage);
  };
  handleChangeRowsPerPage = (event) => {
    this.props.setRowsPerPage(event.target.value);
    this.props.setPage(0);
  };
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === ASC;
    this.setState({
      order: isAsc ? DESC : ASC,
      orderBy: property,
    });
  };
  getDisplayed = (rows) => {
    if (!rows) return [];
    return [
      ...rows.slice(
        this.props.page * this.props.rowsPerPage,
        (this.props.page + 1) * this.props.rowsPerPage
      ),
    ];
  };

  uncheckAll() {
    const newEntries = {};
    this.props.setSelected(newEntries, false, null);
  }

  handleCheck(e, employeeSession) {
    const isChecked = e.target.checked;

    // If checked, clear all and set only current one
    let newEntries = isChecked ? { [employeeSession.clockId]: true } : {}; // If unchecked, clear all

    this.props.setSelected(
      newEntries,
      !!this.numSelected(newEntries),
      employeeSession
    );
  }

  // handleCheck(e, employeeSession) {
  //   let newEntries = {
  //     ...this.props.checkedEntries,
  //     [employeeSession.clockId]: e.target.checked,
  //   };
  //   this.props.setSelected(
  //     newEntries,
  //     !!this.numSelected(newEntries),
  //     employeeSession
  //   );
  // }
  selectAll(e) {
    let newChecked = {};
    const filteredData = this.state.selectedName
      ? this.props.data.filter((emp) => emp.name === this.state.selectedName)
      : this.props.data;
    let allEntries = this.getDisplayed(
      this.stableSort(
        this.applyOverviewFilters(this.filterBySearch(filteredData)),
        this.getComparator(this.state.order, this.state.orderBy)
      )
    );
    allEntries.map((entry) => (newChecked[entry.sessionId] = e.target.checked));
    this.props.setSelected(newChecked, !!this.numSelected(newChecked));
  }
  numSelected(checkedEntries) {
    const filteredData = this.state.selectedName
      ? this.props.data.filter((emp) => emp.name === this.state.selectedName)
      : this.props.data;
    let rows = this.getDisplayed(
      this.stableSort(
        this.applyOverviewFilters(this.filterBySearch(filteredData)),
        this.getComparator(this.state.order, this.state.orderBy)
      )
    );
    return rows.reduceRight(
      (accum, curr) => accum + (checkedEntries[curr.clockId] ?? 0),
      0
    );
  }

  toggleFiltersDialog = () => {
    this.setState({
      showFilters: !this.state.showFilters,
      filtersMapBeforeOpenDialog: { ...this.state.filtersMap },
    });
  };

  onFiltersInputChange = (name, val) => {
    const filtersMap = { ...this.state.filtersMap };

    // if filter already exists, then update
    if (val !== '' && val.length !== 0) {
      filtersMap[name] = val;
    } else {
      delete filtersMap[name];
    }

    this.saveUpdatedStatus(filtersMap);

    this.setState({
      filtersMap: filtersMap,
    });
  };

  saveUpdatedStatus = (filters) => {
    delete filters['fromDate'];
    delete filters['toDate'];
  };

  handleDateChange = (date, key) => {
    const filtersMap = { ...this.state.filtersMap };

    if (
      (key === 'fromDate' && !this.isDefaultFromDate(date)) ||
      (key === 'toDate' && !this.isToday(date))
    ) {
      filtersMap[key] = date;
    } else {
      delete filtersMap[key];
    }
    this.setState({
      filtersMap: filtersMap,
      [key]: date,
    });
    this.props.handleDateChange(date, key);
  };

  onFiltersClose = (applyFilters, saveFilterSetting) => {
    // NOTE: changes are already applied as the user makes these changes,
    // but if the changes are cancelled, then the map is reverted to its
    // previous state
    this.setState({
      showFilters: false,
    });
    let filters = {};
    if (!applyFilters) {
      filters = { ...this.state.filtersMapBeforeOpenDialog };
      this.resetDateFilters(
        filters?.fromDate ?? this.getFromDate(),
        filters?.toDate ?? this.getToDate(),
        filters
      );
    } else {
      if (this.state.deletedTagsWithCookies.length > 0) {
        let storage = JSON.parse(localStorage.getItem('employeeSession'));
        this.state.deletedTagsWithCookies.forEach((tagName) => {
          delete storage[tagName];
        });
        localStorage.setItem('employeeSession', JSON.stringify(storage));
        if (JSON.stringify(storage) === JSON.stringify({}))
          localStorage.removeItem('employeeSession');
        this.setState({ deletedTagsWithCookies: [] });
      }
      filters = { ...this.state.filtersMap };
      const expiry = new Date().setHours(23, 59, 59, 0);
      let needRefresh = this.props.fetchedList;
      if (filters.fromDate !== null && filters.fromDate !== undefined) {
        let existing = localStorage.getItem('employeeSession');
        existing = existing ? JSON.parse(existing) : {};
        if (existing.fromDate !== filters.fromDate.toISOString()) {
          needRefresh = true;
        }
        existing.fromDate = filters.fromDate;
        localStorage.setItem('employeeSession', JSON.stringify(existing));
        localStorage.setItem('expiry', JSON.stringify(expiry));
      }
      if (filters.toDate !== null && filters.toDate !== undefined) {
        let existing = localStorage.getItem('employeeSession');
        existing = existing ? JSON.parse(existing) : {};
        if (existing.toDate !== filters.toDate.toISOString()) {
          needRefresh = true;
        }
        existing.toDate = filters.toDate;
        localStorage.setItem('employeeSession', JSON.stringify(existing));
        localStorage.setItem('expiry', JSON.stringify(expiry));
      }
      //fetching all the employee session
      if (this.props.data.length === 0 || needRefresh) {
        this.fetchEmployeeSession(this.state.fromDate, this.state.toDate);
        this.props.setFetchedList(false);
      }
    }
    if (saveFilterSetting) {
      this.saveUpdatedStatus(filters);
    }
  };

  resetDateFilters = (fromDate, toDate, filters) => {
    if (!this.isDefaultFromDate(fromDate)) {
      filters['fromDate'] = fromDate;
    } else {
      delete filters['fromDate'];
      fromDate = this.getFromDate();
    }
    if (!this.isToday(toDate)) {
      filters['toDate'] = toDate;
    } else {
      delete filters['toDate'];
      toDate = this.getToDate();
    }
    this.setState({
      fromDate: fromDate,
      toDate: toDate,
      filtersMap: filters,
      deletedTagsWithCookies: [],
    });
    this.props.handleDateChange(fromDate, 'fromDate');
    this.props.handleDateChange(toDate, 'toDate');
  };

  onTagClickedWhenDialogueOpen = (event, tag) => {
    const filtersMap = { ...this.state.filtersMap };
    let tagValue = filtersMap[tag];
    let deletedTagsWithCookies = this.state.deletedTagsWithCookies;
    delete filtersMap[tag];
    if (tag === 'fromDate') {
      let storage = JSON.parse(localStorage.getItem('employeeSession'));
      if (storage) {
        if (storage.fromDate !== null && storage.fromDate !== undefined) {
          if (
            new Date(storage.fromDate).getTime() ===
            new Date(tagValue).getTime()
          ) {
            this.setState({
              deletedTagsWithCookies: [...deletedTagsWithCookies, 'fromDate'],
            });
          }
        }
      }
      this.setState({
        fromDate: this.getFromDate(),
      });
    }
    if (tag === 'toDate') {
      let storage = JSON.parse(localStorage.getItem('employeeSession'));
      if (storage) {
        if (storage.toDate !== null && storage.toDate !== undefined) {
          if (
            new Date(storage.toDate).getTime() === new Date(tagValue).getTime()
          ) {
            this.setState({
              deletedTagsWithCookies: [...deletedTagsWithCookies, 'toDate'],
            });
          }
        }
      }
      this.setState({
        toDate: this.getToDate(),
      });
    }
    this.saveUpdatedStatus(filtersMap);
    this.setState({
      filtersMap: filtersMap,
    });
  };

  onTagClicked = (event, tag) => {
    // remove the key from the filters map
    // clone the map, delete the key, set the state
    const filtersMap = { ...this.state.filtersMap };
    delete filtersMap[tag];
    if (tag === 'fromDate') {
      let storage = JSON.parse(localStorage.getItem('employeeSession'));
      delete storage.fromDate;
      this.setState(
        {
          fromDate: this.getFromDate(),
        },
        () => this.fetchEmployeeSession(this.state.fromDate, this.state.toDate)
      );
      localStorage.setItem('employeeSession', JSON.stringify(storage));
      if (JSON.stringify(storage) === JSON.stringify({}))
        localStorage.removeItem('employeeSession');
    }
    if (tag === 'toDate') {
      let storage = JSON.parse(localStorage.getItem('employeeSession'));
      delete storage.toDate;
      this.setState(
        {
          toDate: this.getToDate(),
        },
        () => this.fetchEmployeeSession(this.state.fromDate, this.state.toDate)
      );
      localStorage.setItem('employeeSession', JSON.stringify(storage));
      if (JSON.stringify(storage) === JSON.stringify({}))
        localStorage.removeItem('employeeSession');
    }

    this.saveUpdatedStatus(filtersMap);
    this.setState({
      filtersMap: filtersMap,
    });
  };

  fetchEmployeeSession = (fromDate, toDate) => {
    this.props.fetchEmployeeSessions({
      fromDate: fromDate,
      toDate: toDate,
      locationId: this.props.user.selectedLocationId,
    });
  };

  applyOverviewFilters = (rows) => {
    const selectedState = this.state.filtersMap?.state || [];
    if (selectedState.length > 0) {
      rows = rows.filter((row) => {
        return selectedState.includes(row.state);
      });
    }
    return rows;
  };

  removeStatusFilters = () => {
    let filters = { ...this.state.filtersMap };
    delete filters['selectedStatus'];
    return filters;
  };

  tableRow = (employee) => {
    return (
      <React.Fragment>
        <TableCell className="table-cell-left">{employee?.clockIn}</TableCell>
        <TableCell className="table-cell-left">{employee?.clockOut} </TableCell>
        <TableCell className="table-cell-left">
          {employee?.totalHours}
        </TableCell>
        <TableCell className="table-cell-left">{employee?.totalPay}</TableCell>
        <TableCell className="table-cell-left">{employee?.state}</TableCell>
      </React.Fragment>
    );
  };

  searchStrings = (employee) => {
    return [employee.clockIn, employee.clockOut];
  };

  clearFiltersMap = () => {
    this.setState({
      dateFiltersMap: {},
      fromDate: this.getFromDate(),
      toDate: this.getToDate(),
    });
  };

  handleDeleteSession = () => {
    this.props.deleteEmployeeSession(
      {
        clockId: this.state.deleteId,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        locationId: this.props.user.selectedLocationId,
      },
      () => {
        this.setState({
          deleteId: '',
        });
      }
    );
  };

  render() {
    const filteredData = this.state.selectedName
      ? this.props.data.filter((emp) => emp.name === this.state.selectedName)
      : this.props.data;

    let rows = this.getDisplayed(
      this.stableSort(
        this.filterBySearch(this.applyOverviewFilters(filteredData)),
        this.getComparator(this.state.order, this.state.orderBy)
      )
    );

    return (
      <React.Fragment>
        <div className="filter-tag-wrapper">
          <FilterTagsBar
            showLabel={true}
            filtersMap={this.removeStatusFilters()}
            onClick={
              this.state.showFilters
                ? this.onTagClickedWhenDialogueOpen
                : this.onTagClicked
            }
          />
        </div>

        <div>
          <CustomTableHeader
            // isSearchBar={false}
            isShowFilter={true}
            searchText={this.props.searchText}
            onSearchValueChange={this.onSearchValueChange}
            pagination={
              <TablePagination
                className="table-pagination"
                labelRowsPerPage={ROWS_PER_PAGE_LABEL}
                rowsPerPageOptions={[
                  5,
                  25,
                  50,
                  100,
                  { value: this.props.data.length, label: 'All' },
                ]}
                count={
                  !this.props.data
                    ? 0
                    : this.filterBySearch(
                        this.applyOverviewFilters(this.props.data)
                      ).length
                }
                rowsPerPage={this.props.rowsPerPage}
                page={this.props.page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            }
            showFilters={this.state.showFilters}
            filtersComponent={
              <Slide
                in={this.state.showFilters}
                mountOnEnter
                unmountOnExit
                timeout={300}
              >
                <EmployeeSessionFiltersDialog
                  open={this.state.showFilters}
                  onClose={this.onFiltersClose}
                  onChange={this.onFiltersInputChange}
                  // listItems={
                  //   STATE_OPTIONS ? STATE_OPTIONS.map((state) => state.name) : []
                  // }
                  handleDateChange={this.handleDateChange}
                  filtersMap={this.state.filtersMap}
                  clearFilters={this.clearFiltersMap}
                  onTagClicked={this.onTagClicked}
                  fromDate={this.state.fromDate}
                  toDate={this.state.toDate}
                  // fieldName={'state'}
                  // fieldTitle={'State'}
                />
              </Slide>
            }
            filterIcon={
              <Tooltip title={'Filter'}>
                <IconButton
                  className="filterButton"
                  size="small"
                  aria-label={'Filter'}
                  onClick={this.toggleFiltersDialog}
                >
                  <FilterIcon />
                </IconButton>
              </Tooltip>
            }
          />
        </div>

        {this.props.isBack === false ? (
          this.displayEmployees()
        ) : (
          <>
            <TableContainer>
              <Table size="medium">
                <GlobalTableHead
                  isCreatePurchaseOrderTable={false}
                  isShipmentTable={false}
                  isPurchaseOrderTable={false}
                  headCells={EMPLOYEE_SESSION_FIELDS}
                  //onSelectAllClick={this.selectAll}
                  numSelected={this.numSelected(this.props.checkedEntries)}
                  isInvoiceTable={false}
                  order={this.state.order}
                  orderBy={this.state.orderBy}
                  onRequestSort={this.handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {rows.map((employeeSession, index) => (
                    <TableRow key={'employeeSession-' + index}>
                      <TableCell style={{ padding: '1rem' }}>
                        <div
                          className="rowSpecSuppliers"
                          // style={{marginRight: '40px', marginLeft: '40px'}}
                        >
                          <Checkbox
                            checked={
                              this.props.checkedEntries[
                                employeeSession.clockId
                              ] ?? false
                            }
                            onChange={(e) =>
                              this.handleCheck(e, employeeSession)
                            }
                          />

                          <IconButton
                            size="small"
                            onClick={() =>
                              this.props.handleEmployeeEditRow(employeeSession)
                            }
                          >
                            <EditIcon />
                          </IconButton>
                        </div>
                      </TableCell>

                      {EMPLOYEE_SESSION_FIELDS.map((headCell, index) => (
                        <TableCell key={index} style={{ textAlign: 'left' }}>
                          {employeeSession[headCell.id]}
                        </TableCell>
                      ))}

                      <TableCell style={{ padding: '5px', width: '205px' }}>
                        {this.state.deleteId !== employeeSession.clockId ? (
                          <IconButton
                            onClick={() =>
                              this.setState({
                                deleteId: employeeSession.clockId,
                              })
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        ) : (
                          <div>
                            <Button
                              onClick={() => this.setState({ deleteId: '' })}
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={this.handleDeleteSession}
                              variant="contained"
                              startIcon={<DeleteIcon />}
                            >
                              Delete
                            </Button>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </React.Fragment>
    );
  }
}

export default EmployeeSessionTable;
